// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { EMPTY_STRING, REG_EXP } from '~/utils/constants/common';
import { IFormForgotPassword } from '~/utils/interface/auth';

export const schema = (t: TFunction) => {
  return yup
    .object()
    .shape({
      email: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' }))
        .test('isValidEmail', t('common_validate_invalid_email', { ns: 'common/base' }), (value) => {
          if (value && !REG_EXP.EMAIL.test(value)) return false;
          return true;
        }),
    })
    .required();
};

export const defaultValuesForm: IFormForgotPassword = {
  email: EMPTY_STRING,
};
